export const SCA_FAILED_ERROR_CODE = -1;
export const exposedErrorCodes = [
  1008,
  2002,
  2007,
  2020,
  2033,
  2035,
  2036,
  3009,
  3022,
  3053,
  3057,
  3061,
  3065,
  4021,
  4033,
  4034,
  SCA_FAILED_ERROR_CODE,
];
export const paymentErrorCodes = [4000, 4003, 4004, 4018, 4019, 4023, 4038, 9009, 9010];
